import { watch } from "vue"

/**
 * Applies a watch to the user details to ensure the contact email matches if one isn't set
 * 
 * @param {Object} form 
 */
export function createFormFieldBookingDetailsWatch(form){
    watch(
        () => form.fields.value.forename,
        (forename) => {
            if(form.fields.value.ticket.people.length > 0){
                form.fields.value.ticket.people[0].forename = forename
            }
        }
    )

    watch(
        () => form.fields.value.middle_name,
        (middle_name) => {
            if(form.fields.value.ticket.people.length > 0){
                form.fields.value.ticket.people[0].middle_name = middle_name
            }
        }
    )

    watch(
        () => form.fields.value.surname,
        (surname) => {
            if(form.fields.value.ticket.people.length > 0){
                form.fields.value.ticket.people[0].surname = surname
            }
        }
    )

    watch(
        () => form.fields.value.contact.email,
        (email) => {
            if(form.fields.value.ticket.people.length > 0){
                form.fields.value.ticket.people[0].email = email
            }
        }
    )
}